import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaLine, FaWhatsapp, FaFacebookF, FaTiktok, } from 'react-icons/fa';

const Footer = () => {
  const [selectedPhone, setSelectedPhone] = useState('0935818543'); // default
  const phones = [
    { label: '093 581 8543', value: '0935818543' },
    { label: '097 494 2356', value: '0974942356' },
    { label: '091 476 7177', value: '0914767177' },
  ];

  return (
    <div style={styles.footerContainer}>
      <div style={styles.footerContent}>
        
          <div style={styles.contactSection}> {/* LINE ขึ้นบรรทัดใหม่บนมือถือ */}
            <div style={styles.lineBreakMobile}></div>
            <a href="https://line.me/ti/p/@summerhouseagent" target="_blank" rel="noopener noreferrer" style={styles.contactIcon}><FaLine /></a>
            
            {/* Social icons */}
            <a href="https://wa.me/+66935818543" target="_blank" rel="noopener noreferrer" style={styles.contactIcon}><FaWhatsapp /></a>
            <a href="https://www.facebook.com/profile.php?id=61578022162935" target="_blank" rel="noopener noreferrer" style={styles.contactIcon}><FaFacebookF /></a>
            <a href="https://www.tiktok.com/@summerhouse.agent" target="_blank" rel="noopener noreferrer" style={styles.contactIcon}><FaTiktok /></a>
          </div>
      

        <div style={styles.phoneContainer}>
          <FaPhoneAlt style={styles.phoneIcon} />
          <select value={selectedPhone} onChange={(e) => setSelectedPhone(e.target.value)} style={styles.phoneSelect}>
            {phones.map((phone) => (
              <option key={phone.value} value={phone.value}>{phone.label}</option>
            ))}
          </select>
          <a href={`tel:${selectedPhone}`} style={styles.callButton}>Call</a>
        </div>


        <p style={styles.footerText}>© 2025 Real Estate App. All rights reserved.</p>

        <div style={styles.footerLinks}>
          
          <Link to="/privacypolicy" style={styles.footerLink}>Privacy Policy</Link>
          <Link to="/termofservice" style={styles.footerLink}>Terms of Service</Link>
          
        </div>

      

      </div>
    </div>
  );
};

const styles = {
  footerContainer: {

  background: 'linear-gradient(135deg, #0f1c2e 0%, #1d3557 50%, #457b9d 100%)',
  color: '#fff',
  padding: '25px 20px',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  boxShadow: '0 -2px 15px rgba(0,0,0,0.2)',
  marginTop: '20px', // เว้นช่องว่างด้านบน 20px
  },
  footerContent: {
    maxWidth: '1200px',
    width: '100%',
    textAlign: 'center',
  },
  footerText: { fontSize: '16px', marginBottom: '12px', color: '#aaa' },
  footerLinks: { display: 'flex', justifyContent: 'center', gap: '25px', marginBottom: '18px' },
  footerLink: { textDecoration: 'none', color: '#fff', fontSize: '16px', fontWeight: 'bold', transition: '0.3s', },
  contactSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    flexWrap: 'wrap',
  },

  phoneContainer: { display: 'flex', alignItems: 'center', gap: '10px' , justifyContent: 'center',margin: 20},
  phoneIcon: { fontSize: '22px', color: '#ffffffff' },
  phoneSelect: {
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    backgroundColor: '#f5f5f5',
    color: '#333',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
  callButton: {
    marginLeft: '10px',
    padding: '8px 16px',
    backgroundColor: '#ffffffff',
    color: '#142438',
    fontWeight: 'bold',
    borderRadius: '8px',
    textDecoration: 'none',
    transition: 'all 0.3s',
  },
  contactIcon: {
    fontSize: '22px',
    color: '#ffffffff',
    transition: 'all 0.3s',
  },

  // media query สำหรับ mobile
  lineBreakMobile: {
    flexBasis: '100%', // ขึ้นบรรทัดใหม่
    height: 0,
  },
};


export default Footer;
